import {h} from 'preact'
import {useEffect} from "preact/hooks";
import {AppPage} from '../_common/components/app-page'
import {C, F} from '../_common/layout'
import {t} from '../_i18n'
import './secretary-styles.scss'
import Card from '../_common/components/CardDashboard/Card'
import {connect, useSelector} from 'react-redux'
import {useHistory} from 'react-router'
import {isSpanishUser, isItalianUser} from "../_common/utils/getLang";
import { fetchNeeDocumentInfo } from "../_rx/student/actions";
import {
    STUDENT_TRIAL,
} from '../app/getUserRol'

function Secretary({ auth, fetchNeeDocumentInfo, isTrial}) {
    const student_meta = useSelector(state => state.status?.student_meta)
    const neeStatus = useSelector(state => state.neeDocumentStatus?.status)
    const showCertPaymentReceiptSection = student_meta.finished_academic_programs.some(ap => ap.closed_academic_record !== false)
    const history = useHistory()

    useEffect(() => { if (!neeStatus) fetchNeeDocumentInfo(auth.loggedUser.id) }, [])

    return (
        <AppPage title={t('Secretaría académica')} back={history.goBack} className="max-width-980">
            <F className="max-width-980">
                <C>
                    {!isTrial && 
                        <div className="m-top secretary__panel">
                            {/*<Card title={t('Solicitar título')} to='/academic-program-card' />*/}
                            { student_meta.is_on_site === false && !isItalianUser(student_meta.shop_id) &&
                                <Card fullWidth title='Certificados' to='/secretaria/solicitar-certificado'/>}
                            { <Card fullWidth title={t('Traspaso de expediente')} to='/secretaria/traspaso-expediente'/>}
                            { student_meta.shop_id === 1 && <Card fullWidth title={t('Aplazar asignaturas')} to='/secretaria/aplazar-asignaturas'/>}
                            { showCertPaymentReceiptSection &&
                                <Card fullWidth title={t('Solicitud de título')} to='/secretaria/solicitud-titulo'/>
                            }
                            { !isSpanishUser(student_meta.shop_id) && student_meta.formative_zone === 'MAD' &&   <Card fullWidth title={t('Homologacion')} to='/secretaria/homologacion'/> }
                            { neeStatus?.enabled && <Card fullWidth title={t('Necesidades educativas especiales')} to='/student/nee'/> }
                            <Card fullWidth title={t('Envío de documentación')} to='/secretaria/documentacion'/>
                        </div>
                    }
                </C>
            </F>
        </AppPage>
    )
}

export default connect(
    (state) => ({
        auth: state.auth,
        isTrial: state.student_access === STUDENT_TRIAL
    }),
    { fetchNeeDocumentInfo }
)(Secretary);
